import { render, staticRenderFns } from "./AddNewPersonDialog.vue?vue&type=template&id=8b147bee&scoped=true"
import script from "./AddNewPersonDialog.vue?vue&type=script&lang=js"
export * from "./AddNewPersonDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewPersonDialog.vue?vue&type=style&index=0&id=8b147bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b147bee",
  null
  
)

export default component.exports